import { useState } from 'react'
import styled from 'styled-components'
import { PillButton } from '../components/common/stand_alone/pillButton'
import { breakpoints } from '../assets/styles/mediaBreakpoints'

const Features = [
  {
    id: 0,
    buttonTitle: 'Action & Challenge',
    featureSubTitle: 'FREE . FUN . EFFECTIVE',
    featureTitle: 'Join Challenges, Earn Rewards',
    featureText:
      'Participate in challenges aligned with your Sustainable Development Goals (SDG) interests. Track your progress, earn badges, and climb the leaderboard while creating real-world change. Together, small actions can lead to big impacts.',
    imgDesktop: '/images/homepage/PlatformFeaturesSection_Desktop-1.png',
    imgMobile: '/images/homepage/PlatformFeaturesSection_Mobile-1.png',
  },
  {
    id: 1,
    buttonTitle: 'Community',
    featureSubTitle: 'COG COMMUNITY',
    featureTitle: 'Helping people do more actions together',
    featureText:
      'Need inspiration or advice? Our CoGs Community allow you to connect directly with other guardians who share your goals. Discuss projects, exchange resources, and support each other as you work toward a better world.',
    imgDesktop: '/images/homepage/PlatformFeaturesSection_Desktop-2.png',
    imgMobile: '/images/homepage/PlatformFeaturesSection_Mobile-2.png',
  },
  {
    id: 2,
    buttonTitle: 'Research Repository',
    featureSubTitle: 'EASY TO ACCESS RESEARCH',
    featureTitle: 'Explore, Learn, and share research for a better world',
    featureText:
      'Get active with daily challenges tailored to your SDG interests. Track your progress, earn badges, and climb the leaderboard as you help create real-world change. Small actions add up to big impacts when we work together.',
    imgDesktop: '/images/homepage/PlatformFeaturesSection_Desktop-3.png',
    imgMobile: '/images/homepage/PlatformFeaturesSection_Mobile-3.png',
  },
]

const HomePage = () => {
  const [activeFeature, setActiveFeature] = useState(Features[0])
  const handleFeatureChange = (id: number) => {
    setActiveFeature(Features[id])
  }
  return (
    <PageContainer>
      <HeroSectionContainer>
        <SectionTextBox $maxW="876px" $gap="16px">
          <HeroSubtitle>COMMUNITY OF GUARDIANS</HeroSubtitle>
          <HeroTitle>Unleash Your Inner Hero Change the World</HeroTitle>
          <HeroDescription>
            It’s no secret that our world is facing serious challenges. If we
            maintain the status quo, we will continue to harm our planet—and
            ultimately ourselves.
          </HeroDescription>
        </SectionTextBox>
        <PillButton
          title="Find Your Superhero"
          link={'/quiz'}
          bg="white"
          textColor="black"
        />
      </HeroSectionContainer>
      <AboutSectionContainer>
        <Logo src="/images/logos/Logo-Symbol.svg" />
        <SectionTextBox $maxW="864px" $gap="24px">
          <AboutTitle>We are real-life superheroes</AboutTitle>
          <p>
            We are Community of Guardians, a global movement of everyday heroes
            united to take action for a better world.
          </p>
          <PillButton title="See More" link="/about" />
        </SectionTextBox>
      </AboutSectionContainer>
      <FeatureSectionContainer>
        <FeatureTitleContainer>
          <SectionTextBox $maxW="864px">
            Building a future where humanity thrives, Protecting our Planet
          </SectionTextBox>
        </FeatureTitleContainer>
        <FeatureButtonContainer>
          {Features.map((feature) =>
            featureButtonGenerator(
              feature.buttonTitle,
              feature.id,
              feature === activeFeature,
              () => handleFeatureChange(feature.id),
            ),
          )}
        </FeatureButtonContainer>
        <FeatureDetailContainer>
          <FeatureDetailImage
            $imgDesktop={activeFeature.imgDesktop}
            $imgMobile={activeFeature.imgMobile}
          />
          <SectionTextBox
            $maxW="392px"
            $gap="16px"
            $textAlign="left"
            $alignItems="flex-start"
            $mobileTextAlign="left"
          >
            <FeatureSubtitle>{activeFeature.featureSubTitle}</FeatureSubtitle>
            <FeatureTitle>{activeFeature.featureTitle}</FeatureTitle>
            <p>{activeFeature.featureText}</p>
          </SectionTextBox>
        </FeatureDetailContainer>
      </FeatureSectionContainer>
      <HowItWorksSectionContainer>
        <SectionTextBox $maxW="612px" $gap="24px">
          <FeatureSubtitle>HOW IT WORKS</FeatureSubtitle>
          <HowItWorksTitle>
            Transform Everyday Actions into Global Impact
          </HowItWorksTitle>
        </SectionTextBox>
        <HowItWorksTilesContainer>
          {howItWorksTileGenerator(
            '/images/homepage/HowItWorksIcon-1.svg',
            'Join Our Community',
            'Sign up and become part of a global community committed to making a difference.',
          )}
          {howItWorksTileGenerator(
            '/images/homepage/HowItWorksIcon-2.svg',
            'Discover Your Passion',
            'Discover your SDG hero and connect with causes that align with your passion.',
          )}
          {howItWorksTileGenerator(
            '/images/homepage/HowItWorksIcon-3.svg',
            'Take Meaningful Action',
            'Participate in challenges, initiatives, and projects designed to drive impact and protect our planet.',
          )}
          {howItWorksTileGenerator(
            '/images/homepage/HowItWorksIcon-4.svg',
            'Earn Rewards & Inspire Others',
            'Earn rewards, share achievements, and inspire others to join the mission.',
          )}
        </HowItWorksTilesContainer>
      </HowItWorksSectionContainer>
      <MissionSectionContainer>
        <MissionTitle>Inspiring Action Through real-Superheroes</MissionTitle>
        <MissionDescription>
          The Community of Guardians unites people to take meaningful steps
          toward achieving the Sustainable Development Goals. By harnessing the
          power of community, we inspire change. Through interactive learning,
          collaborative projects, and rewarding actions, we empower you to
          become a true guardian of the planet.
        </MissionDescription>
      </MissionSectionContainer>
      <IntroduceHeroSection>
        <SectionTextBox $maxW="425px" $textAlign="left">
          <IntroduceHeroTitle>
            Curious to find out what’s your number? Which hero is most like you?
          </IntroduceHeroTitle>
        </SectionTextBox>
        <PillButton title="Find Your Superhero" link={'/quiz'} />
      </IntroduceHeroSection>
    </PageContainer>
  )
}

const featureButtonGenerator = (
  title: string,
  id: number,
  isActive: boolean,
  onClick: (id: number) => void,
) => {
  return (
    <FeatureButtonPill onClick={() => onClick(id)} $isActive={isActive}>
      <FeatureButtonTitle>{title}</FeatureButtonTitle>
    </FeatureButtonPill>
  )
}
const howItWorksTileGenerator = (
  icon: string,
  title: string,
  description: string,
) => {
  return (
    <HowItWorkContainer>
      <HowItWorksIcon src={icon} />
      <SectionTextBox
        $maxW="300px"
        $gap="8px"
        $alignItems="flex-start"
        $textAlign="left"
        $mobileTextAlign="left"
      >
        <h5>{title}</h5>
        <p>{description}</p>
      </SectionTextBox>
    </HowItWorkContainer>
  )
}

const PageContainer = styled.div`
  flex-grow: 1;
`
const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`
const HeroSectionContainer = styled(SectionContainer)`
  padding: 84px 282px;
  background-image: url('/images/homepage/HeroSection_Desktop.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 100%;
  height: 800px;
  gap: 32px;
  @media (max-width: ${breakpoints.desktop}px) {
    background-image: url('/images/homepage/HeroSection_Mobile.png');
    padding: 84px 24px;
    height: 1020px;
    background-position: 50% 70%;
  }
`
const SectionTextBox = styled(SectionContainer).attrs<{
  $maxW?: string
  $gap?: string
  $textAlign?: string
  $mobileTextAlign?: string
  $alignItems?: string
}>((props) => ({
  $maxW: props.$maxW ?? '100%',
  $gap: props.$gap ?? '0',
  $textAlign: props.$textAlign ?? 'center',
  $mobileTextAlign: props.$mobileTextAlign ?? 'center',
  $alignItems: props.$alignItems ?? 'center',
}))`
  max-width: ${({ $maxW }) => $maxW};
  text-align: ${({ $textAlign }) => $textAlign};
  gap: ${({ $gap }) => $gap};
  align-items: ${({ $alignItems }) => $alignItems};
  @media (max-width: ${breakpoints.desktop}px) {
    text-align: ${({ $mobileTextAlign }) => $mobileTextAlign};
    max-width: 100%;
  }
`
const HeroSubtitle = styled.h6`
  font-size: 16px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors['primary-500']};
`
const HeroTitle = styled.h1`
  color: white;
  font-weight: 700;
  @media (max-width: ${breakpoints.desktop}px) {
    font-size: 40px;
  }
`
const HeroDescription = styled.p`
  color: white;
  font-weight: normal;
`
const AboutSectionContainer = styled(SectionContainer)`
  padding: 80px 0;
  gap: 32px;
  justify-content: center;
  @media (max-width: ${breakpoints.desktop}px) {
    padding: 80px 24px;
  }
`
const Logo = styled.img`
  width: 100%;
  height: 96px;
`
const AboutTitle = styled.h1`
  font-size: 56px;
  @media (max-width: ${breakpoints.desktop}px) {
    font-size: 40px;
  }
`
const FeatureSectionContainer = styled(SectionContainer)`
  padding: 32px 24px 80px;
  gap: 64px;
  @media (max-width: ${breakpoints.desktop}px) {
    gap: 24px;
  }
`
const FeatureTitleContainer = styled.h2`
  @media (max-width: ${breakpoints.desktop}px) {
    font-size: 32px;
  }
`
const FeatureButtonContainer = styled.div`
  display: flex;
  gap: 24px;
  margin-top: 12px;
  justify-content: center;
  @media (max-width: ${breakpoints.desktop}px) {
    width: 100%;
    overflow-x: auto;
    gap: 8px;
    padding: 12px 4px;
    margin-top: 0;
    justify-content: flex-start;
  }
`
const FeatureButtonPill = styled.div.attrs<{
  $isActive?: boolean
}>((props) => ({
  $isActive: props.$isActive ?? false,
}))`
  box-sizing: border-box;
  padding: 12px 20px;
  border-radius: 999px;
  background-color: ${({ theme, $isActive }) =>
    $isActive ? theme.colors['primary-500'] : 'white'};
  outline: ${({ theme, $isActive }) =>
    $isActive ? 'none' : `1px solid ${theme.colors['gray-300']}`};
  cursor: pointer;
  transition: all 0.3s;
  white-space: nowrap;
  &:hover {
    background-color: ${({ theme, $isActive }) =>
      $isActive ? theme.colors['primary-500'] : theme.colors['primary-300']};
    outline: none;
  }
`
const FeatureButtonTitle = styled.h6`
  font-size: 16px;
  font-weight: 700;
`
const FeatureDetailContainer = styled.div`
  display: flex;
  gap: 56px;
  align-items: center;
  @media (max-width: ${breakpoints.desktop}px) {
    flex-direction: column;
    gap: 24px;
  }
`
const FeatureDetailImage = styled.img.attrs<{
  $imgDesktop?: string
  $imgMobile?: string
}>((props) => ({
  $imgDesktop: props.$imgDesktop ?? '',
  $imgMobile: props.$imgMobile ?? '',
}))`
  width: 640px;
  height: 100%;
  object-fit: cover;
  content: url(${({ $imgDesktop }) => $imgDesktop});
  @media (max-width: ${breakpoints.desktop}px) {
    width: 100%;
    max-width: 400px;
    content: url(${({ $imgMobile }) => $imgMobile});
  }
`
const FeatureSubtitle = styled.h6`
  font-size: 16px;
`
const FeatureTitle = styled.h4`
  @media (max-width: ${breakpoints.desktop}px) {
    font-size: 24px;
  }
`
const HowItWorksSectionContainer = styled(SectionContainer)`
  padding: 128px 64px;
  gap: 64px;
  @media (max-width: ${breakpoints.desktop}px) {
    padding: 32px 24px 80px;
    gap: 32px;
  }
`
const HowItWorksTitle = styled.h3`
  @media (max-width: ${breakpoints.desktop}px) {
    font-size: 32px;
  }
`
const HowItWorksTilesContainer = styled.div`
  display: flex;
  gap: 40px;
  @media (max-width: ${breakpoints.desktop}px) {
    flex-direction: column;
    gap: 32px;
  }
`
const HowItWorkContainer = styled.div`
  display: flex;
  gap: 32px;
  flex-direction: column;
  @media (max-width: ${breakpoints.desktop}px) {
    gap: 16px;
  }
`
const HowItWorksIcon = styled.img`
  width: 48px;
  object-fit: contain;
`
const MissionSectionContainer = styled(SectionContainer)`
  padding: 0 209px;
  height: 822px;
  flex-direction: row;
  gap: 110px;
  background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
    url('/images/homepage/OurMission_AllDevice.jpg');
  justify-content: center;
  align-items: center;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  @media (max-width: ${breakpoints.desktop}px) {
    flex-direction: column;
    height: 852px;
    padding: 0 24px;
    text-align: center;
    gap: 24px;
  }
`
const MissionTitle = styled.h2`
  color: ${({ theme }) => theme.colors['primary-500']};
  flex: 1;
  @media (max-width: ${breakpoints.desktop}px) {
    font-size: 24px;
    flex: 0;
  }
`
const MissionDescription = styled.p`
  color: white;
  flex: 1;
  @media (max-width: ${breakpoints.desktop}px) {
    flex: 0;
  }
`
const IntroduceHeroSection = styled(SectionContainer)`
  height: 617px;
  padding: 0 64px;
  background-image: url('/images/homepage/IntroduceSuperheroesSection_Desktop.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  gap: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  @media (max-width: ${breakpoints.desktop}px) {
    background-image: url('/images/homepage/IntroduceSuperheroesSection_Mobile.png');
    padding: 80px 24px;
    justify-content: flex-start;
    align-items: center;
    height: 780px;
  }
`
const IntroduceHeroTitle = styled.h2`
  @media (max-width: ${breakpoints.desktop}px) {
    font-size: 32px;
  }
`

export default HomePage
